// @flow

import ReduxFormRadioGroup from './radiogroup.reduxform';

export default ReduxFormRadioGroup;
